import { Card } from "@mui/material";
import { IThemeProps } from "component/theme";
import styled from "styled-components";
import { styledCardItem, styledMaxLines } from "system/styles/globalStyles";

export interface IQuickLinkCardProps extends IThemeProps {
  $disabled?: boolean;
}

export const StyledQuickLinkCard = styled(Card)`
  ${({ theme, $disabled }: IQuickLinkCardProps) => `
    position: relative;
    width: ${theme.uptimeDynamicAlignCenter?.quickLink?.card?.width ?? "100%"} ;
    height: ${theme.uptimeDynamicAlignCenter?.quickLink?.card?.height ?? "146px"}!important;
    padding: ${theme.uptimeDynamicAlignCenter?.quickLink?.card?.padding ?? `${theme.uptimeSpace[6]}px`};
    max-width: auto;
    aspect-ratio: 1;
    display: flex;
    flex-direction: column;
    font-size: ${theme.uptimeDynamicFontSize?.quickLinkCard?.general?.sm};
    ${styledCardItem()}
    ${ $disabled ? `
      background-color: ${theme.uptimeColors?.quickLink?.disabled?.background ?? "#ffffff"} !important;
      cursor: unset;
      box-shadow: ${theme.uptimeColors?.quickLink?.disabled?.boxShadow} !important;
      ` : `
      &:hover {
        transition: box-shadow 0.3s;
      }`
    }
    .title {
      font-weight: bold;
      font-size: ${theme.uptimeDynamicFontSize?.quickLinkCard?.title ?? '16px'};
      line-height: ${theme.uptimeDynamicAlignCenter?.quickLink?.title?.lineHeight ?? 'unset'};
      min-height: ${theme.uptimeDynamicAlignCenter?.quickLink?.title?.minHeight ?? 'fit-content'};
      ${styledMaxLines(theme.uptimeDynamicAlignCenter?.quickLink?.title?.maxLines ?? 2)}
    }
    .subtitle {
      min-height: 30px;
      margin: 0;
      color: ${theme.uptimeColors.grayScales.darkerGray};
      font-size: ${theme.uptimeDynamicFontSize?.quickLinkCard?.subTitle ?? '13px'};
      line-height: ${theme.uptimeDynamicAlignCenter?.quickLink?.subTitle?.lineHeight};
      word-break: break-word;
      ${styledMaxLines(theme.uptimeDynamicAlignCenter?.quickLink?.subTitle?.maxLines ?? 2)}
    }
    .btn-link {
      position: absolute;
      left: 12px;
      bottom: 12px;
      button {
        width: 100%;
        padding: 9px 10px 11px;
        font-size: ${theme.uptimeFontSizes.desktop.fz1}px;
        text-transform: capitalize !important;
        height: auto;
        min-height: auto;
        min-width: auto;
        line-height: 1;
        .MuiButton-label {
          display: block;
          width: auto;
          padding: ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[0]}px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      &.long-txt {
        right: 12px;
      }
    }
    @media (min-width: ${theme.breakpoints.md}) {
      max-width: 170px;
      font-size: ${theme.uptimeDynamicFontSize?.quickLinkCard?.general?.lg};
    }
  `}
`;

export const StyledTitle = styled.div<{ isSubtitleBold?: boolean; showButton?: boolean }>(
  ({ theme, isSubtitleBold, showButton }) => `
  flex: 1;
  display: flex;
  flex-direction: column;
  ${!showButton ? `justify-content: ${theme.uptimeDynamicAlignCenter?.quickLink?.textWrapper?.justifyContent ?? 'space-between'};` : ""}
  margin-top: ${theme.uptimeDynamicAlignCenter?.quickLink?.textWrapper?.marginTop ?? `${theme.uptimeSpace[2]}px`};
  .subtitle {
    font-weight: ${isSubtitleBold ? "bold" : "normal"};
  }
`
);

export const StyledQuickLinkIcon = styled.div<{ shadow?: boolean; props?: any }>(
  ({ theme, shadow, props }) => `
  .MuiSvgIcon-root {
    color: ${theme.uptimeColors.generalColors.icon.smallCard};
  }
  &.icon {
    display: inline-block;
    width: ${props?.width ?? theme.uptimeDynamicAlignCenter?.quickLink?.icon?.width ?? '33px'};
    height: ${props?.height ?? theme.uptimeDynamicAlignCenter?.quickLink?.icon?.height ?? '33px'};
    margin-left: ${props?.marginLeft ?? '0'};
    margin-top: ${props?.marginTop ?? '0'};
    border-radius: 4px;
    color: ${theme.uptimeColors.generalColors.icon.smallCard};
  }
  ${
    !!shadow &&
    `
      box-shadow: 0px 2px 6px -1px rgb(0 0 0 / 14%),
                  1px 2px 5px 0px rgb(0 0 0 / 10%),
                  0px 1px 7px 0px rgb(0 0 0 / 12%);

      &:hover {
        cursor: pointer;
        box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
                    0 3px 6px 0 rgba(0, 0, 0, 0.12),
                    0 5px 12px 4px rgba(0, 0, 0, 0.09);
      }
    `
  }
  &:not(:last-of-type) {
    margin-right: ${theme.uptimeSpace[2]}px;
  }
  
  & > * {
    padding: ${
      shadow
        ? `${theme.uptimeSpace[3]}px`
        : `${theme.uptimeDynamicAlignCenter?.quickLink?.icon?.padding ?? `${theme.uptimeSpace[2]}px ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[2]}px 0`}`
    };
    width: 100% !important;
    height: 100% !important;
  }
  `
);
